import { render, staticRenderFns } from "./RespostaNew.vue?vue&type=template&id=8ead1242&scoped=true&"
import script from "./RespostaNew.vue?vue&type=script&lang=js&"
export * from "./RespostaNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ead1242",
  null
  
)

export default component.exports